import { useState } from "react";

import { Card, CardActionArea, CardContent, Typography } from "@mui/material";

import { DateTime } from "luxon";

import { IncidentFootage } from "types/Incident";
import { IncidentViewerFootage } from "./IncidentViewerFootage";
import IncidentViewerFootageDialog from "./IncidentViewerFootageDialog";

export interface IncidentViewerIncidentPanelFootageProps {
    footage: IncidentFootage;
}

export function IncidentViewerIncidentPanelFootage(
    props: IncidentViewerIncidentPanelFootageProps,
) {
    const [showDialog, setShowDialog] = useState(false);

    return (
        <>
            {showDialog && (
                <IncidentViewerFootageDialog
                    footage={props.footage}
                    onClose={() => setShowDialog(false)}
                />
            )}
            <Card
                key={props.footage.id}
                sx={{
                    width: 345,
                    flexShrink: 0,
                }}
            >
                <CardActionArea
                    sx={{
                        height: "100%",
                    }}
                    onClick={() => setShowDialog(!showDialog)}
                >
                    <IncidentViewerFootage
                        sx={{
                            maxHeight: "calc(100% - 53px)",
                        }}
                        footage={props.footage}
                    />

                    <CardContent
                        sx={{
                            height: 53,
                        }}
                    >
                        <Typography
                            align="center"
                            sx={(theme) => ({
                                color: theme.palette.text.primary,
                                fontSize: 14,
                            })}
                        >
                            {DateTime.fromISO(
                                props.footage.timestamp,
                            ).toLocaleString(DateTime.TIME_WITH_SECONDS)}
                            <Typography
                                component={"span"}
                                align="center"
                                sx={(theme) => ({
                                    color: theme.palette.text.secondary,
                                    fontSize: 14,
                                    paddingLeft: 1,
                                })}
                            >
                                {props.footage.deviceName}
                            </Typography>
                        </Typography>
                    </CardContent>
                </CardActionArea>
            </Card>
        </>
    );
}
